import React, { useContext } from 'react'
import StepFigure from '../StepFigure'
import { CarOrderingContext } from "../../../CarOrdering";
import StepSetting from "../StepSetting";

export default function Step2() {
  const {
    steps,
  } = useContext(CarOrderingContext)

  const step = steps.find(step => step.id === 2)
  const settingElements = step.settings
    .map((setting, index) => <StepSetting key={index} setting={setting}/>)

  return (
    <div id='step-2'>
      <StepFigure/>

      <div className='form sticky'>
        <h1 className='mobile-config-title config-title'>
          {step.title}
        </h1>

        {typeof step?.description === 'string' && step.description.length > 0 && (
          <>
            <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: step.description }}/>
            <div className='config-seperator'/>
          </>
        )}

        {settingElements}
      </div>
    </div>
  )
}
